import { render, staticRenderFns } from "./ProjectDocuments.vue?vue&type=template&id=074fd5ec"
import script from "./ProjectDocuments.vue?vue&type=script&lang=js"
export * from "./ProjectDocuments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports